import type { BreadcrumbItem } from '@constant/seo/site';
import { routeList } from '@routes/routeList';

const homeCrumb: BreadcrumbItem = {
  label: 'خانه',
  href: routeList.homeRoute,
};

export const seoBreadcrumbs = {
  home: [homeCrumb],
  nobat: [
    homeCrumb,
    { label: 'نوبتدهی آنلاین پزشکان', href: routeList.nobatHome },
  ],
  ocs: [
    homeCrumb,
    { label: 'مشاوره پزشکی آنلاین', href: '/app/ocs' },
  ],
  medicine: [
    homeCrumb,
    { label: 'داروخانه آنلاین', href: routeList.medicineHome },
  ],
  otcMedicine: [
    homeCrumb,
    { label: 'داروخانه آنلاین', href: routeList.medicineHome },
    { label: 'داروهای بدون نسخه', href: routeList.otcMedicine },
  ],
  prescriptionMedicine: [
    homeCrumb,
    { label: 'داروخانه آنلاین', href: routeList.medicineHome },
    { label: 'داروی نسخه‌ای', href: routeList.prescriptionMedicine },
  ],
  equipment: [
    homeCrumb,
    { label: 'داروخانه آنلاین', href: routeList.medicineHome },
    { label: 'تجهیزات پزشکی', href: routeList.equipmentPage },
  ],
  hygiene: [
    homeCrumb,
    { label: 'داروخانه آنلاین', href: routeList.medicineHome },
    { label: 'بهداشت فردی', href: routeList.hygienePage },
  ],
  supplement: [
    homeCrumb,
    { label: 'داروخانه آنلاین', href: routeList.medicineHome },
    { label: 'مکمل غذایی و ورزشی', href: routeList.supplementPage },
  ],
  motherKid: [
    homeCrumb,
    { label: 'داروخانه آنلاین', href: routeList.medicineHome },
    { label: 'محصولات مادر و کودک', href: routeList.motherKidPage },
  ],
  thirteenAbanPharmacies: [
    homeCrumb,
    { label: 'داروخانه آنلاین', href: routeList.medicineHome },
    { label: 'داروخانه ایثار (MS)', href: routeList.ThirteenAban },
  ],
  nobatSpecialities: [
    homeCrumb,
    { label: 'نوبت حضوری', href: routeList.nobatHome },
    { label: 'تخصص‌های پزشکی', href: routeList.nobatSpecialities },
  ],
  ocsSpecialities: [
    homeCrumb,
    { label: 'مشاوره پزشکی آنلاین', href: '/app/ocs' },
    { label: 'تخصص‌های پزشکی', href: routeList.specialities },
  ],
  onlineDoctorsAll: [
    homeCrumb,
    { label: 'مشاوره پزشکی آنلاین', href: '/app/ocs' },
    {
      label: 'پزشکان آنلاین',
      href: '/app/ocs/online-doctors/all',
    },
  ],
  clinics: [
    homeCrumb,
    { label: 'مراکز درمانی', href: routeList.clinics },
  ],
} as const satisfies Record<string, BreadcrumbItem[]>;

export const buildOnlineDoctorsBreadcrumbs = (
  specialityId: string,
): BreadcrumbItem[] => {
  const path = `/app/ocs/online-doctors/${specialityId}`;

  if (specialityId === 'all') {
    return [...seoBreadcrumbs.onlineDoctorsAll];
  }

  return [
    ...seoBreadcrumbs.onlineDoctorsAll,
    { label: 'لیست پزشکان', href: path },
  ];
};

export const buildMedicalCentersBreadcrumbs = ({
  path,
  typePath,
  typeTitle,
  cityName,
  specialtyTitle,
}: {
  path: string;
  typePath?: string;
  typeTitle: string;
  cityName?: string;
  specialtyTitle?: string;
}): BreadcrumbItem[] => {
  const crumbs: BreadcrumbItem[] = [...seoBreadcrumbs.clinics];

  if (typeTitle) {
    crumbs.push({ label: typeTitle, href: typePath || path });
  }

  if (cityName) {
    crumbs.push({ label: cityName, href: path });
  }

  if (specialtyTitle) {
    crumbs.push({ label: specialtyTitle, href: path });
  }

  return crumbs;
};
